import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useRef } from "react";
import PropTypes from "prop-types";
import { extendedSystemStylesProps } from "@mixins";
import { Flex, SearchInput } from "@base-ui";
import { Options, Option, OptionText } from "./searchableSelect.styles";
import { useOpen, useClickOutside, useCustomEffect } from "hooks";
import handleKeyDown from "./handleKeyDown";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["color", "space", "layout", "flexbox", "border"];
var SearchableSelect = function SearchableSelect(props) {
  var id = props.id,
    label = props.label,
    options = props.options,
    onChange = props.onChange,
    inverted = props.inverted,
    selected = props.selected,
    autoFocus = props.autoFocus,
    error = props.error,
    searchString = props.searchString,
    search = props.search,
    disabled = props.disabled,
    placeholder = props.placeholder,
    disabledLabel = props.disabledLabel,
    hideLabel = props.hideLabel,
    className = props.className;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    activeFocus = _useState2[0],
    setActiveFocus = _useState2[1]; //idx
  var _useOpen = useOpen(false),
    open = _useOpen.open,
    setOpen = _useOpen.setOpen;
  var searchRef = useRef();
  var containerRef = useRef();
  var optionsRef = useRef();
  var clickSelect = function clickSelect(idx) {
    setActiveFocus(-1);
    setOpen(false);
    onChange(idx);
  };
  useCustomEffect(function () {
    if (searchString.length < 3 && open) setOpen(false);else if (searchString.length > 2 && !open) setOpen(true);
  }, [searchString]);
  handleKeyDown(id, containerRef, searchRef, optionsRef, open, setOpen, activeFocus, setActiveFocus, searchString, search, options);
  useClickOutside(containerRef, function () {
    setOpen(false);
    setActiveFocus(-1);
  }, open);
  var optionsMarkup = options.map(function (option, idx) {
    return /*#__PURE__*/_jsx(Option, {
      id: "".concat(id, "-option-").concat(idx),
      title: option.label,
      "aria-selected": selected === idx,
      activeFocus: activeFocus === idx,
      role: "option",
      onClick: function onClick() {
        return clickSelect(idx);
      },
      children: /*#__PURE__*/_jsx(OptionText, {
        children: option.label
      })
    }, option.id);
  });
  return /*#__PURE__*/_jsxs(Flex.Column, _objectSpread(_objectSpread({
    ref: containerRef,
    className: className,
    style: {
      position: "relative"
    }
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(SearchInput, {
      id: "".concat(id, "-input"),
      searchRef: searchRef,
      ariaHasPopup: "listbox",
      ariaExpanded: open,
      ariaControls: "".concat(id, "-listbox"),
      ariaAutocomplete: "list",
      value: searchString,
      label: !disabled ? label : disabledLabel,
      search: search,
      error: error,
      inverted: inverted,
      placeholder: placeholder,
      disabled: disabled,
      autoFocus: autoFocus,
      onFocus: function onFocus() {
        return options.length > 0 && setOpen(true);
      },
      title: disabled ? disabledLabel : undefined,
      hideLabel: hideLabel,
      icon: "search"
    }), /*#__PURE__*/_jsx(Options, {
      id: "".concat(id, "-listbox"),
      role: "listbox",
      "aria-labelledby": "".concat(id, "-label"),
      "aria-activedescendant": "".concat(id, "-option-").concat(selected),
      ref: optionsRef,
      tabIndex: -1,
      open: open,
      children: optionsMarkup
    })]
  }));
};
SearchableSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  _selected: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  inverted: PropTypes.bool,
  hideLabel: PropTypes.bool,
  className: PropTypes.string,
  selectedPrefix: PropTypes.any
};
SearchableSelect.defaultProps = {
  _selected: 0,
  hideLabel: false
};
export default SearchableSelect;